var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-tabs",class:[{'full-width': _vm.fullWidth, 'disabled': _vm.disabled}]},[_c('div',{staticClass:"basic-tabs-inner"},[_vm._t("default",null,null,{ value: _vm.value })],2)])}
var staticRenderFns = []

export { render, staticRenderFns }